import React from 'react'
import { RestaurantInfo } from '../../api/restaurant/getRestaurant'
import { NewLineFormatter } from '../NewLineFormatter/NewLineFormatter'
import { Experience } from '../../api/experiences/model'
import { DividingLine } from '@toasttab/buffet-pui-config-templates'

type TextFooterProps = {
  restaurant: RestaurantInfo
  experience: Experience
}

export const ExperienceTextFooter = ({
  restaurant,
  experience
}: TextFooterProps) => {
  // showReservationPolicy falls back to true if not experience or policyOverride not set
  const experiencePolicyOverride = experience.policyOverride || {
    showReservationPolicy: true,
    description: null
  }

  const shouldShowReservationPolicy =
    experiencePolicyOverride.showReservationPolicy &&
    restaurant.onlineReservationsEnabled &&
    (restaurant.reservationPolicy?.trim().length ?? 0) > 0

  const shouldShowExperiencePolicy =
    (experiencePolicyOverride.description?.trim().length ?? 0) > 0

  return (
    <div className='flex flex-col gap-4'>
      {restaurant.description?.trim() ? (
        <>
          <div className='flex flex-col gap-1'>
            <h2 className='type-large font-semibold'>About</h2>
            <div className='text-secondary'>
              <NewLineFormatter text={restaurant.description} />
            </div>
          </div>
          <DividingLine />
        </>
      ) : null}
      {shouldShowReservationPolicy && (
        <div className='flex flex-col gap-1'>
          <h2 className='type-large font-semibold'>Reservation policy</h2>
          <div className='text-secondary'>
            <NewLineFormatter text={restaurant.reservationPolicy} />
          </div>
        </div>
      )}
      {shouldShowExperiencePolicy && (
        <div className='flex flex-col gap-1'>
          <h2 className='type-large font-semibold'>Experience policy</h2>
          <div className='text-secondary'>
            <NewLineFormatter text={experiencePolicyOverride.description} />
          </div>
        </div>
      )}
      <DividingLine />
    </div>
  )
}
